import { TreeNode } from '../types';

export function setParentNode(node: TreeNode, parent: TreeNode | null = null): TreeNode {
    const newNode = {
        ...node,
        parent: parent ?? null,
    };

    return {
        ...node,
        parent: parent ?? null,
        children: node.children?.map(child => setParentNode(child, newNode)),
    };
}
